import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'ProductInfoList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/ea/asset/info',
      pageTitle: '产品清单',
      xAxisData: [],
      series: [],
      autoLoadInit: false,
      tabKeys: '1',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns1: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'productCode',
        colName: 'product_code',
        title: '产品编号',
        align: 'center'
      }, {
        dataIndex: 'productName',
        colName: 'productName',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'model',
        colName: 'model',
        title: '规格型号',
        align: 'center'
      }, {
        dataIndex: 'companyName',
        colName: 'companyName',
        title: '供应商',
        align: 'center'
      }, {
        dataIndex: 'sumTotal',
        colName: 'sumTotal',
        title: '总数',
        align: 'center'
      }, {
        dataIndex: 'validNum',
        colName: 'validNum',
        title: '有效数量',
        align: 'center'
      }, {
        dataIndex: 'noValidNum',
        colName: 'noValidNum',
        title: '无效数量',
        align: 'center'
      }],
      columns2: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'sumTotal',
        colName: 'sumTotal',
        title: '总数',
        align: 'center'
      }, {
        dataIndex: 'validNum',
        colName: 'validNum',
        title: '有效数量',
        align: 'center'
      }, {
        dataIndex: 'noValidNum',
        colName: 'noValidNum',
        title: '无效数量',
        align: 'center'
      }],
      companyList: [],
      url: {
        queryCompany: '/ea/company/info/queryCompanyName',
        delete: '/ea/asset/info',
        device: '/ea/asset/equipment',
        chemical: '/ea/asset/chemical',
        car: '/ea/asset/car',
        list: '/ea/asset/info/static'
      }
    };
  },
  props: {
    category: {
      type: Number,
      default: 11
    },
    title: {
      type: String,
      default: '设备'
    }
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.category = this.category;

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.columns = this.columns1;
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        //this.queryParam.siteId = undefined
        this.columns = this.columns2;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.loadData();
    },
    tabKeys: function tabKeys(value) {
      var _this = this;

      if (value == '2') {
        this.$nextTick(function () {
          _this.drawChart1(_this.xAxisData, _this.series);
        });
      }
    }
  },
  created: function created() {
    this.tabKeys = '1';
    this.loadCompany();
    this.queryParam.category = this.category; // this.loadData()
    // this.$forceUpdate()
  },
  computed: {},
  methods: {
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        category: this.category
      };
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        category: this.category
      };
      this.dates = {};
      this.loadData(1);
    },
    initTableData: function initTableData(arg) {
      var _this2 = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result.records;
          _this2.ipagination.total = res.result.total;

          _this2.loadChartData();
        } else {
          _this2.$message.warning('系统异常=>' + res.message);
        }

        _this2.loading = false;
      });
    },
    loadChartData: function loadChartData() {
      var _this3 = this;

      var param = this.queryParam;
      param.current = 1;
      param.size = 99999999;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, param).then(function (res) {
        if (res.success) {
          var record = res.result.records;
          var chartData = record.filter(function (item, idx) {
            return item != undefined;
          });
          var xAxisData = [];
          var yesData = [];
          var noData = [];

          if (0 < chartData.length) {
            chartData.forEach(function (item, index) {
              if (_this3.queryParam.scope == 1) {
                xAxisData.push(item.productName);
              } else {
                xAxisData.push(item.siteName);
              }

              yesData.push(item.validNum);
              noData.push(item.noValidNum);
            });
          }

          var series = [{
            name: '有效数',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: yesData
          }, {
            name: '无效数',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: noData
          }];
          _this3.xAxisData = xAxisData;
          _this3.series = series;

          _this3.drawChart1(xAxisData, series);
        }
      });
    },
    drawChart1: function drawChart1(xAxisData, series) {
      var myEchart = this.$echarts.init(document.getElementById('histogramMain'));
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        title: {
          text: '设备仪表统计',
          left: 'center',
          top: 20,
          textStyle: {
            color: '#ccc'
          }
        },
        legend: {
          data: ['有效数', '无效数']
        },
        // grid: {
        //   containLabel: true,
        // },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: series
      };
      myEchart.setOption(option);
    }
  }
};